import { connect } from 'react-redux';

import { TThunkDispatch, IReduxState } from '../../types/redux';
import { setBedroomsCount } from '../../actions/filters';
import { FilterBedrooms, IFilterBedroomsProps } from '../../components/FilterBedrooms';

type TFilterRoomTypeStateProps = Pick<IFilterBedroomsProps, 'value'>;
type TFilterRoomTypeDispatchProps = Pick<IFilterBedroomsProps, 'onChange'>;

function mapStateToProps(state: IReduxState): TFilterRoomTypeStateProps {
  return {
    value: state.filters.jsonQuery.bedroom_total && state.filters.jsonQuery.bedroom_total.value.gte || null,
  };
}

function mapDispatchToProps(dispatch: TThunkDispatch): TFilterRoomTypeDispatchProps {
  return {
    onChange: (bedroomsCount: number) => dispatch(setBedroomsCount(bedroomsCount)),
  };
}

export const FilterBedroomsContainer = connect(mapStateToProps, mapDispatchToProps)(FilterBedrooms);
